import { action } from 'satcheljs';

export const removeSecondaryUserEmail = action('removeSecondaryUserEmail', (email: string) => ({
    email,
}));
